<script>
  let {
    url,
    text = '',
    ...restProps
  } = $props()
</script>

<a {...restProps} href="{url}" target="_blank" {...restProps}>{text}</a> <sup><i class="bi bi-arrow-up-right"></i></sup>
